// extracted by mini-css-extract-plugin
module.exports = {"containrer":"countryCard_containrer__15E0Z","ph":"countryCard_ph__QLrxN","image":"countryCard_image__1OY6m"};